// import { AuthenticatedTemplate, useMsal } from '@azure/msal-react';
export const PageLayout = (props) => {
    return (
        <>
            {props.children}
        </>
    );
}